"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalType = exports.SignalTypeDeprecated = void 0;
var SignalTypeDeprecated;
(function (SignalTypeDeprecated) {
    SignalTypeDeprecated["Power"] = "power";
    SignalTypeDeprecated["PowerGND"] = "power.gnd";
    SignalTypeDeprecated["PowerVCC"] = "power.vcc";
    SignalTypeDeprecated["PowerVEE"] = "power.vee";
    SignalTypeDeprecated["PowerAnalogGND"] = "power.agnd";
    SignalTypeDeprecated["PowerAnalogVCC"] = "power.avcc";
})(SignalTypeDeprecated || (exports.SignalTypeDeprecated = SignalTypeDeprecated = {}));
var SignalType;
(function (SignalType) {
    SignalType["Power"] = "power";
    SignalType["Ground"] = "ground";
    SignalType["Analog"] = "analog";
    SignalType["Digital"] = "digital";
    SignalType["NoConnect"] = "nc";
})(SignalType || (exports.SignalType = SignalType = {}));
//# sourceMappingURL=SignalTypeDeprecated.js.map